
@if (product$ | async; as product) {
  <div class="technical-installation">
    @if (!product?.isAccesories) {
      <div class="technical-container">
        <h2 class="section-title">Technical &amp; Installation</h2>
        @for (s of sections; track s) {
          <div class="collapsible-section" [class.open]="openSections[s.key]">
            <div class="collapsible-header" (click)="toggleSection(s.key)">
              <span class="collapsible-title">{{ s.label }}</span>
              <span class="collapsible-icon">
                {{ openSections[s.key] ? '−' : '+' }}
              </span>
            </div>
            @if (openSections[s.key]) {
              <div class="collapsible-content">
                <div class="document-list">
                  @for (data of product?.additionalDatas; track data) {
                    @if (data.productDetailType === s.key) {
                      <div class="document-item">
                        <div class="document-info">
                          <div class="document-name">{{ data.title }}</div>
                          <div class="document-type">{{ data.mediaType }}</div>
                        </div>
                        <button class="document-download"
                          (click)='download(data)'>
                          {{ 'productSummary.download' | cxTranslate }}
                        </button>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}